import * as React from "react"
import PropTypes from "prop-types"
import {Link} from "gatsby"
import "../../../images/logo-normal.png"
import Navbar from "./navbar/navbar"
import Hero from "./hero/hero"
import "./header.css"
import Title from "../title/title";
import {useEffect, useState} from "react";

const Header = ({isHomePage, pageName}) => {

    const [scroll, setScroll] = useState(true)
    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY < 500
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck)
            }
        })
    })

    return (
        <header>
            <div className={`container`}>
                <Navbar scroll={scroll}/>
                {isHomePage && <Hero/>}
                {!isHomePage && <Title pageName={pageName}/>}
            </div>
        </header>
    )
}

export default Header